import { bool, func, shape } from 'prop-types';
import React from 'react';
import RecipeFirstStickyNav from 'components/RecipeFirstStickyNav';
import PostBundleItem from 'components/PostBundleItem';
import RecipeFirstRecipe from 'components/RecipeFirstRecipe';
import styles from './styles';

function RecipeFirst(props) {
  const { post, recipe, image, customPropsMapper } = props;

  return (
    <div className="RecipeFirst">
      {/* Render Recipe First Navigation */}
      <RecipeFirstStickyNav recipe={recipe} post={post} />
      {/* Render Post Image */}
      <PostBundleItem
        idx={0}
        item={{
          id: image.id,
          type: 'image',
          __typename: image.__typename,
          data: { ...image }
        }}
        customPropsMapper={customPropsMapper}
        isAmp={false}
      />
      {/* Render Recipe First Recipe */}
      <RecipeFirstRecipe post={post} recipe={recipe} />
      <style jsx>{styles}</style>
      <div id="recipe-story" />
    </div>
  );
}

RecipeFirst.defaultProps = {
  customPropsMapper: undefined
};

RecipeFirst.propTypes = {
  customPropsMapper: func,
  recipe: shape({}).isRequired,
  image: shape({}).isRequired,
  post: shape({}).isRequired
};

export default RecipeFirst;
